import { ConnectButton } from '@rainbow-me/rainbowkit';
import styled from 'styled-components';

const StyledButton = styled.button`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 16px;
  background: white;
  border: 1px solid white;
  border-radius: 9999px; /* rounded-full */
  color: black;
  font-size: 12px; /* text-xs */
  font-weight: 500;
  transition: opacity 0.2s;
  
  &:hover {
    opacity: 0.9;
  }

  /* Mengatasi warna SVG di dalamnya */
  & svg path {
    fill: black; /* Diubah menjadi hitam agar kontras dengan background putih tombol */
  }
`;

const AddressText = styled.span`
  font-family: monospace;
`;

export const ConnectButtonCustom = () => {
  return (
    <ConnectButton.Custom>
      {({ account, chain, openAccountModal, openChainModal, openConnectModal, authenticationStatus, mounted }) => {
        const ready = mounted && authenticationStatus !== 'loading';
        const connected = ready && account && chain && (!authenticationStatus || authenticationStatus === 'authenticated');

        if (!connected) {
          return (
            <StyledButton onClick={openConnectModal} type="button">
              {/* SVG Asli dari kode HTML Anda */}
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none" className="[&>path]:fill-black flex-none">
                <path d="M14.3 9.093v.667c0 .18-.14.327-.327.333H13c-.353 0-.673-.26-.7-.606-.02-.207.06-.4.193-.534a.63.63 0 0 1 .467-.193h1.007a.334.334 0 0 1 .333.333"></path>
                <path d="M11.993 8.46a1.35 1.35 0 0 0-.36 1.32c.174.62.78 1.013 1.42 1.013h.58c.367 0 .667.3.667.667v.127a2.51 2.51 0 0 1-2.507 2.506H4.14a2.51 2.51 0 0 1-2.507-2.506V7.1c0-.82.394-1.547 1-2 .42-.32.94-.507 1.507-.507h7.653A2.51 2.51 0 0 1 14.3 7.1v.293c0 .367-.3.667-.667.667h-.68c-.373 0-.713.147-.96.4M10.8 3.213c.18.18.027.46-.227.46l-5.12-.006c-.293 0-.446-.36-.233-.567L6.3 2.013a2.35 2.35 0 0 1 3.307 0l1.166 1.18c.007.007.02.014.027.02"></path>
              </svg>
              Connect Wallet
            </StyledButton>
          );
        }

        if (chain.unsupported) {
          return (
            <StyledButton onClick={openChainModal} type="button" style={{ background: '#ff4d4d', color: 'white', border: 'none' }}>
              Wrong network
            </StyledButton>
          );
        }

        return (
          <div style={{ display: 'flex', gap: 12 }}>
            <StyledButton onClick={openAccountModal} type="button">
              {/* SVG Dompet tetap ada saat terkoneksi */}
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none">
                 <path fill="black" d="M14.3 9.093v.667c0 .18-.14.327-.327.333H13c-.353 0-.673-.26-.7-.606-.02-.207.06-.4.193-.534a.63.63 0 0 1 .467-.193h1.007a.334.334 0 0 1 .333.333 M11.993 8.46a1.35 1.35 0 0 0-.36 1.32c.174.62.78 1.013 1.42 1.013h.58c.367 0 .667.3.667.667v.127a2.51 2.51 0 0 1-2.507 2.506H4.14a2.51 2.51 0 0 1-2.507-2.506V7.1c0-.82.394-1.547 1-2 .42-.32.94-.507 1.507-.507h7.653A2.51 2.51 0 0 1 14.3 7.1v.293c0 .367-.3.667-.667.667h-.68c-.373 0-.713.147-.96.4M10.8 3.213c.18.18.027.46-.227.46l-5.12-.006c-.293 0-.446-.36-.233-.567L6.3 2.013a2.35 2.35 0 0 1 3.307 0l1.166 1.18c.007.007.02.014.027.02"></path>
              </svg>
              <AddressText>{account.displayName}</AddressText>
            </StyledButton>
          </div>
        );
      }}
    </ConnectButton.Custom>
  );
};